module.exports = __webpack_public_path__ + "media/images/emblems/Mies-coat_of_arms-9e36d0fd521efb0fbbbbf501454730a1.svg";